import { useTranslation } from "react-i18next";

import DefaultFilterList from "./DefaultFilterList";

export default function DepartmentsFilter(props) {
	const { t } = useTranslation();

	if (props.departments.length === 0) {
		return null;
	}

	return (
		<div data-test-id="departments-filter">
			<DefaultFilterList
				{...props}
				title={t("filters.exams.departments.title")}
				list={props.departments}
			/>
		</div>
	);
}
